export const appBaseURL = "/cert/"

export const appRootId = "nuxt-app"

export const appBuildAssetsDir = "assets"

export const appCdnURL = "https://s5-edu.51cto.com/edu/edu-cert-plat-fe"

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"build-date","content":"Tue, 10 Sep 2024 11:34:24 GMT"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=5"},{"name":"format-detection","content":"telephone=no"},{"http-equiv":"x-dns-prefetch-control","content":"on"},{"name":"keywords","content":"IT考试认证,PMP认证,华为认证,hcia,hcip,hcie,cisp,cissp,cda,软考,红帽认证,rhce,信息系统项目管理师,cka,cks,itil,npdp,软件设计师,acp,oca,ocp,cisa,aws,kos认证,微软认证,ccna,ccnp,ccie,OceanBase,数据治理,通信工程师,TDSQL,SCMP,vcp,scsa"},{"name":"description","content":"IT人才认证中心为程序员、IT技术人员、IT从业者提供有效的证书考试信息、行业资讯、报考价格、备考课程、备考经验与建议、考生评价、市场热度，企业需求、帮助您选择适合您的证书并助力您备考！"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"canonical","href":"https://edu.51cto.com/cert/"},{"rel":"dns-prefetch","href":"https://s5-edu.51cto.com/"}],"style":[],"script":[],"noscript":[],"title":"IT人才认证中心_IT考试认证_专业认证，为你赋能！","htmlAttrs":{"lang":"zh-CN","style":""}}

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootTag = "div"

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#nuxt-app'

export const viewTransition = false